/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react';

export const MarkerIcon = ({ className }) => {
  return (
    <svg
      fill="#ffffff"
      height="22"
      width="22"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 346.351 346.351"
      xmlSpace="preserve"
      stroke="#ffffff"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />

      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <g id="SVGRepo_iconCarrier">
        {' '}
        <g>
          {' '}
          <path d="M344.153,61.722L289.881,7.451c-1.407-1.406-3.315-2.196-5.304-2.196c-1.988,0-3.896,0.79-5.303,2.197l-10.263,10.263 l-3.274-3.274c-2.87-2.871-7.503-2.936-10.453-0.149L46.657,212.206c-1.05,1.05-1.764,2.389-2.053,3.846l-13.407,67.685 L1.227,329.486c-1.51,2.305-1.635,5.252-0.325,7.676c1.31,2.424,3.844,3.935,6.599,3.935h159.511c4.143,0,7.5-3.357,7.5-7.5 s-3.357-7.5-7.5-7.5H62.827l5.847-5.848l66.882-13.246c1.457-0.289,2.796-1.004,3.846-2.054L337.314,96.324 c2.787-2.95,2.721-7.583-0.148-10.452l-3.276-3.276l10.266-10.267C347.083,69.4,347.083,64.651,344.153,61.722z M21.38,326.096 l18.109-27.646l14.885,14.884l-12.76,12.762H21.38z M130.406,292.731L67.452,305.2l-21.047-21.046l12.471-62.953l8.512-8.513 l71.53,71.531L130.406,292.731z M149.372,273.46l-71.225-71.226l16.243-15.343l70.323,70.324L149.372,273.46z M175.019,246.305 L105.3,176.586L236.437,52.725l62.443,62.445L175.019,246.305z M309.185,104.26l-61.838-61.839l12.938-12.221l61.119,61.123 L309.185,104.26z M323.284,71.987l-43.666-43.666l4.959-4.96l43.667,43.665L323.284,71.987z" />{' '}
        </g>{' '}
      </g>
    </svg>
  );
};
